export const LOAN_TYPE_LABEL_MAP: Record<string, string> = {
  thirty_year: "30 Year Fixed",
  fifteen_year: "15 Year Fixed",
  arm: "ARM",
  fha: "FHA",
  va: "VA",
  usda: "USDA",
  thirty_year_jumbo: "30 Year Jumbo",
  fifteen_year_jumbo: "15 Year Jumbo",
  jumbo_arm: "Jumbo ARM",
  thirty_year_ldp: "30 Year LDP",
  fifteen_year_ldp: "15 Year LDP",
  va_ldp: "VA LDP",
  va_zdp: "VA ZDP",
  fifteen_year_va: "15 Year VA",
  fifteen_year_va_ldp: "15 Year VA LDP",
  fifteen_year_va_zdp: "15 Year VA ZDP",
  thirty_year_refi: "30 Year Refinance",
  fifteen_year_refi: "15 Year Refinance",
  arm_refi: "ARM Refinance",
  fha_refi: "FHA Refinance",
  va_refi: "VA Refinance"
}

export const formatKey = (key: string) =>
  key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())

export const isRefi = (key: string) => key.endsWith("_refi")

export const toLoanTypes = (keys: string[]) =>
  keys.map(key => ({ key, label: LOAN_TYPE_LABEL_MAP[key] ?? formatKey(key) }))

export const toDefaultTabOptions = (
  loanTypes: { key: string; label: string }[]
) => loanTypes.map(lt => ({ type: lt.key, label: lt.label }))
